import { useState } from 'react';

import { Banner } from '@/components/Banner';

export const MigrationBanner = () => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Banner
      open={true}
      intent="warning"
      shadow={false}
      closeable={false}
      title="Migrate your deployment"
      description={
        <div className="flex flex-col gap-2 text-tertiary">
          <span>
            This deployment is running on legacy infrastructure. Automatic
            migration is scheduled for June 15th, 10am PST. There should be no
            disruption to your deployment during this process.
          </span>
          {expanded ? (
            <>
              <span>
                Note that you will be unable to deploy new revisions during the
                migration.
              </span>
              <button
                onClick={() => setExpanded(false)}
                type="button"
                className="w-fit text-primary underline"
              >
                <span>See less</span>
              </button>
            </>
          ) : (
            <button
              onClick={() => setExpanded(true)}
              type="button"
              className="w-fit text-primary underline"
            >
              <span>See more</span>
            </button>
          )}
        </div>
      }
    />
  );
};
